import { Component, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../../environments/environment";
import { interval, Subscription } from 'rxjs';
import { MatTabsModule } from '@angular/material/tabs';
@Component({
  selector: 'app-log-viewer-dialog',
  template: `
    <div mat-dialog-content class="tw-m-6 tw-p-6 tw-shadow-lg">
      <div class="tw-flex tw-justify-between tw-mb-4">
        <h2 class="tw-text-2xl tw-font-semibold">Log Viewer</h2>
        <span class="tw-text-sm">Next update in: {{countdown}}s</span>
      </div>
      
      <div class="tw-flex tw-justify-between tw-mb-4">
        <span>Backend Logs</span>
        <div class="tw-flex tw-gap-2">
          <button mat-button (click)="clearBackendLogs()">
            <mat-icon>delete</mat-icon>
            Clear
          </button>
          <button mat-button (click)="copyToClipboard(backendLogs)">
            <mat-icon>content_copy</mat-icon>
            Copy
          </button>
        </div>
      </div>

      <pre class="log-viewer-pre tw-p-4 tw-rounded tw-overflow-auto tw-h-96 tw-font-mono">
        {{ backendLogs }}
      </pre>

      <div class="tw-mt-4 tw-flex tw-justify-end tw-gap-2">
        <button mat-raised-button color="primary" (click)="clearAllLogs()">
          <mat-icon>delete_sweep</mat-icon>
          Clear All
        </button>
        <button mat-raised-button (click)="dialogRef.close()">
          <mat-icon>close</mat-icon>
          Close
        </button>
      </div>
    </div>
  `
})
export class LogViewerDialogComponent implements OnDestroy {
  backendLogs: string = '';
  frontendLogs: string = '';
  private backendEventSource: EventSource;
  private frontendEventSource: EventSource;
  private backendPreviousLog: string = '';
  private frontendPreviousLog: string = '';
  private pollSubscription: Subscription;
  countdown: number = 10;
  private countdownSubscription: Subscription;

  constructor(
    private http: HttpClient,
    public dialogRef: MatDialogRef<LogViewerDialogComponent>
  ) {
    this.startPolling();
    this.startCountdown();
  }

  startCountdown() {
    this.countdownSubscription = interval(1000).subscribe(() => {
      this.countdown = this.countdown > 0 ? this.countdown - 1 : 10;
    });
  }

  startPolling() {
    this.pollSubscription = interval(10000).subscribe(() => {
      this.connectToSSE();
    });
  }

  copyToClipboard(text: string) {
    navigator.clipboard.writeText(text);
  }
  
  clearBackendLogs() {
    this.backendLogs = '';
    this.backendPreviousLog = '';
  }
  
  clearFrontendLogs() {
    this.frontendLogs = '';
    this.frontendPreviousLog = '';
  }
  
  clearAllLogs() {
    this.clearBackendLogs();
    this.clearFrontendLogs();
  }

  connectToSSE() {
    // Backend logs
    if (this.backendEventSource) {
      this.backendEventSource.close();
    }
    this.backendEventSource = new EventSource(`${environment.SERVER_URL}/logs/backendlogfiles`);
    this.backendEventSource.onmessage = (event) => {
      try {
        const logData = JSON.parse(event.data);
        if (logData !== this.backendPreviousLog) {
          const diff = logData.slice(this.backendPreviousLog.length);
          this.backendLogs += diff + '\n';
          this.backendPreviousLog = logData;
        }
      } catch (e) {
        console.error('Error parsing backend log data:', e);
      }
    };
  }

  ngOnDestroy() {
    if (this.backendEventSource) {
      this.backendEventSource.close();
    }
    if (this.pollSubscription) {
      this.pollSubscription.unsubscribe();
    }
    if (this.countdownSubscription) {
      this.countdownSubscription.unsubscribe();
    }
  }
}